import React from 'react'
import map from 'lodash/map'
import { DisplayFactory } from './DisplayFactory'
import { useProductMetadata } from './useProductMetadata'
import type { ProductMetadata } from '@ztechapps/common.contract'
import { useMetadataContext } from './Context'

export type MetadataDisplayContentProps = { value: ProductMetadata[] }
export const MetadataDisplayContent = ({ value }: MetadataDisplayContentProps) => {
  const { metadataSchema } = useProductMetadata()
  const { compact } = useMetadataContext()

  return (
    <table className="table table-hover table-striped   ">
      <thead>
        <tr>
          <th style={{ width: '50%' }}>Keys</th>
          <th>Values</th>
        </tr>
      </thead>
      <tbody>
        {map(value, (metadata, index) => {
          const schemaItem = metadataSchema?.[metadata?.key]

          return (
            <tr key={index}>
              <td>
                <div>
                  <b>{schemaItem?.name || metadata?.key || metadata?.description}</b>
                </div>
                {!compact && <small>{metadata?.description || schemaItem?.description}</small>}
              </td>
              <td>
                <div>
                  <DisplayFactory schema={schemaItem} metadata={metadata} />
                </div>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
